import { SIGNATURE_HEADER } from "./constants";
import { escapeUri } from "@aws-sdk/util-uri-escape";
/**
 * @internal
 */
export function getCanonicalQuery(_a) {
    var _b = _a.query, query = _b === void 0 ? {} : _b;
    var keys = [];
    var serialized = {};
    var _loop_1 = function (key) {
        if (key.toLowerCase() === SIGNATURE_HEADER) {
            return "continue";
        }
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") {
            serialized[key] = escapeUri(key) + "=" + escapeUri(value);
        }
        else if (Array.isArray(value)) {
            serialized[key] = value
                .slice(0)
                .sort()
                .reduce(function (encoded, value) {
                return encoded.concat([escapeUri(key) + "=" + escapeUri(value)]);
            }, [])
                .join("&");
        }
    };
    for (var _i = 0, _c = Object.keys(query).sort(); _i < _c.length; _i++) {
        var key = _c[_i];
        _loop_1(key);
    }
    return keys
        .map(function (key) { return serialized[key]; })
        .filter(function (serialized) { return serialized; }) // omit any falsy values
        .join("&");
}
//# sourceMappingURL=getCanonicalQuery.js.map